var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewBadgeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 16,
    viewBox: "0 0 34 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NEW",
    transform: "translate(-902 -248)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1829",
    "data-name": "Rectangle 1829",
    width: 34,
    height: 16,
    rx: 3,
    transform: "translate(902 248)",
    fill: "#08c467"
  }), /*#__PURE__*/React.createElement("text", {
    id: "NEW-2",
    "data-name": "NEW",
    transform: "translate(911 259)",
    fill: "#fff",
    fontSize: 7,
    fontFamily: "Silka-Regular, Silka"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "NEW")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBadgeIcon);
export default __webpack_public_path__ + "static/media/new-badge-icon.94796869dc31de572eab8a861b1ee44b.svg";
export { ForwardRef as ReactComponent };